import React from 'react';
import { PanAnimation, PanNavAnimation } from './Pan.styles';
import { AnimationComponentProps } from '../types';

export const PAN_DEFAULT_SPEED = 1;

export const Pan = (props: AnimationComponentProps) => {
  const {
    children,
    speed = PAN_DEFAULT_SPEED,
    direction,
    translateXPercent = 5,
    isNav,
    numberNavItems = 9,
    delay,
    easeFunction = 'cubic-bezier(0.1, 0, 0.1, 1)',
  } = props;
  const { panDirection } = direction || {};

  if (isNav) {
    const navAnimationSpeed = speed / numberNavItems;

    return (
      <PanNavAnimation
        navAnimationSpeed={navAnimationSpeed}
        speed={speed}
        easeFunction={easeFunction}
        translateXPercent={translateXPercent}
      >
        {children}
      </PanNavAnimation>
    );
  }
  return (
    <PanAnimation
      speed={speed}
      easeFunction={easeFunction}
      direction={panDirection || 'right'}
      delay={delay || 0}
      translateXPercent={translateXPercent}
    >
      {children}
    </PanAnimation>
  );
};
